"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.StyledModalHideTab = exports.StyledModalHeader = exports.StyledModalFooter = exports.StyledModalCloseButton = exports.StyledModalBody = exports.StyledModal = void 0;

var _modal = _interopRequireDefault(require("./modal"));

var _modalHeader = _interopRequireDefault(require("./modal-header"));

var _modalBody = _interopRequireDefault(require("./modal-body"));

var _modalFooter = _interopRequireDefault(require("./modal-footer"));

var _modal2 = require("./modal.styles");

exports.StyledModalHideTab = _modal2.StyledModalHideTab;
exports.StyledModalCloseButton = _modal2.StyledModalCloseButton;
exports.StyledModalHeader = _modal2.StyledModalHeader;
exports.StyledModalBody = _modal2.StyledModalBody;
exports.StyledModalFooter = _modal2.StyledModalFooter;
exports.StyledModal = _modal2.StyledModal;
_modal.default.Header = _modalHeader.default;
_modal.default.Body = _modalBody.default;
_modal.default.Footer = _modalFooter.default;
var _default = _modal.default;
exports.default = _default;